import { useCallback, useState } from 'react';

export const useLocalStorageState = <T>(
  key: string,
  defaultValue: T
): [T, (value: T) => void] => {
  const [state, setState] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? defaultValue : (JSON.parse(stored) as T);
    } catch {
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (value: T) => {
      try {
        if (value === null) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, JSON.stringify(value));
        }
      } catch {
        // ignore write errors (e.g. storage quota exceeded)
      }
      setState(value);
    },
    [key]
  );

  return [state, setValue];
};
